// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"b81ef325","100":"6df978c8","228":"e5d7d632","380":"f867e542","444":"ce5876b1","592":"a705bc27","704":"708bbe8e","884":"7437d30c","920":"b24de921","952":"71aaa113"}[chunkId] + ".chunk.js";
};